// src/components/common/Sidebar.tsx
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  Calendar,
  LogOut,
  ChevronLeft,
  ChevronRight,
  User,
  Settings,
  HelpCircle,
  Building,
} from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

interface SidebarProps {
  isOpen: boolean;
  onToggle?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onToggle }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const menuItems = [
    { icon: LayoutDashboard, label: "Dashboard", path: "/" },
    { icon: Calendar, label: "Airport Transfers", path: "/bookings?type=transfer" },
    { icon: Building, label: "Hotel Checks", path: "/bookings?type=hotel-check" },
  ];


  return (
    <aside
      className={`fixed left-0 top-16 h-[calc(100vh-4rem)] bg-white border-r border-gray-200 transition-all duration-300 flex flex-col shadow-sm ${
        isOpen ? "w-64" : "w-0 overflow-hidden"
      }`}
    >
      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-4 px-3">
        <div className="space-y-1">
          {menuItems.map((item) => {
            const isActive = item.path.includes("?") 
              ? (location.pathname === item.path.split("?")[0] && location.search === "?" + item.path.split("?")[1])
              : location.pathname === item.path;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 group ${
                  isActive
                    ? "bg-primary text-white shadow-md shadow-primary/20"
                    : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                }`}
              >
                <item.icon size={20} className="flex-shrink-0" />
                <span className="font-medium text-sm">{item.label}</span>
                {isActive && (
                  <span className="ml-auto w-1.5 h-6 bg-white/60 rounded-full" />
                )}
              </NavLink>
            );
          })}
        </div>

        {/* {bottomItems.length > 0 && (
          <div className="mt-6 pt-6 border-t border-gray-200 space-y-1">
            {bottomItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 ${
                    isActive
                      ? "bg-primary text-white shadow-md shadow-primary/20"
                      : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                  }`
                }
              >
                <item.icon size={20} className="flex-shrink-0" />
                <span className="font-medium text-sm">{item.label}</span>
              </NavLink>
            ))}
          </div>
        )} */}
      </nav>

      {/* Bottom */}
      <div className="flex-shrink-0 border-t border-gray-200 px-3 py-3 space-y-2">
        <button
          onClick={logout}
          className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-rose-600 hover:bg-rose-50 hover:text-rose-700 transition-all duration-200 group"
        >
          <div className="w-8 h-8 rounded-full bg-rose-50 group-hover:bg-rose-100 flex items-center justify-center transition-colors">
            <LogOut size={18} className="flex-shrink-0" />
          </div>
          <span className="font-medium text-sm">Logout</span>
          <span className="ml-auto text-xs text-rose-400 group-hover:text-rose-600 transition-colors">
            Sign out
          </span>
        </button>

        {onToggle && (
          <button
            onClick={onToggle}
            className="w-full flex items-center justify-center gap-2 px-3 py-2 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-all duration-200"
          >
            {isOpen ? (
              <>
                <ChevronLeft size={18} />
                <span className="text-xs font-medium">Collapse</span>
              </>
            ) : (
              <>
                <ChevronRight size={18} />
                <span className="text-xs font-medium">Expand</span>
              </>
            )}
          </button>
        )}
      </div>
    </aside>
  );
};

export default Sidebar;